var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: '_item', base: xP.base, prototype: {
    init: function (params) {
      xP.controls._item.base.init.apply(this, arguments);

      if (!this.$element) {
        this.create();
      }

      xP.debug('controls', 'control', this.type, this.$element, this);

      if (!this.$container && this.container_selector) {
        this.$container
          = this.$element.parents(this.container_selector).first();
      }

      if (!this.$container || !this.$container.length) {
        this.$container = this.$element;
      }

      var a = ['disabled', 'required', 'autofocus', 'min', 'max', 'step'],
        i = a.length, v;

      while (i--) {
        v = this.$element.attr(a[i]);

        if (v !== undefined && !this[a[i]] !== undefined) {
          this[a[i]] = v;
        }
      }

      if (this.autofocus) {
        // TODO: Надо подумать, как лучше поступать при disabled.
        this.$element.focus();
      }

//			if(!this.valid){
//				v = this.$element.attr('pattern');
//
//				if(v){
//					this.valid = new RegExp(v);
//				}else{
//					v = xP.dependencies.valid_match[
//						this.$element.attr('type')
//					];
//
//					if(v){
//						this.valid = v;
//					}
//				}
//			}

      var that = this;


      this._init_val();

      if (this.disabled || this.enabled === false) {
        this.disabled = false;
        // Чтобы отключить добавленные элементы (secret).
        xP.after(function () {
          that.disable();
        });
      }

      xP.after(function () {
        that.change();
        that._init_val();
      });


      if (!this._.parent) {
        // TODO: Дописать перемещение детей из родителя.
        this.$element.parentsUntil('body').each(function () {
          var control = xP.controls.link($(this));

          if (control) {
            that._.parent = control;
            return false;
          }
        });
      }

      if (this._.parent && !(this instanceof xP.controls.form)) {
        this._.no_root_dependencies
          = this._.parent._.no_root_dependencies;

        this._.parent._.children.append(this);

        this._.root = this._.parent._.root;
      } else {
        this._.root = this;
      }

      xP.controls.link(this.$element, this);
      xP.controls.link(this.$container, this);

      this.name = this.$element.attr('name') || this.name;

      if (xP.repeats) {
        xP.repeats.init(this);
      }

      xP.dependencies.init(this);
    },

    remove: function () {
      var $container = this.$container,
      // TODO: Вынести эту функцию.
        destroy_with_children = function (parent) {
          if (parent.children) {
            parent.children().each(function () {
              destroy_with_children(this);
            });
          }

          parent.destroy();
        };

      destroy_with_children(this);

      $container.remove();
    },

    destroy: function (handler, remove) {
      xP.controls._item.base.destroy.apply(this, arguments);

      if (!arguments.length) {
        if (this._.parent) {
          this._.parent._.children.remove(this);
        }

        this.$container
          = this.$element
          = null;
      }
      return this;
    },

    parent: function () {
      return this._.parent;
    },

    root: function () {
      return this._.root;
    },

    _init_val: function () {
      this._.initial_value
        = this._.value
        = this.val();
    },

    val: function (value) {
      if (!arguments.length) {
        return '';
      } else {
        this.change();

        return this;
      }
    },

    disable: function (disabled) {
      disabled = !arguments.length || disabled;

      if (this.disabled !== disabled) {
        if (disabled) {
          this.$element.add(
            this.$container.addClass(
              this.container_disabled_class
            )
          ).attr('disabled', true);
        } else {
          var parent = this;

          while ((parent = parent.parent()) && parent != this) {
            if (parent.disabled) {
              return this;
            }
          }

          this.$element.add(
            this.$container.removeClass(
              this.container_disabled_class
            )
          ).removeAttr('disabled');
        }

        this.disabled = disabled;

        this.change();
      }
      return this;
    },

    container_disabled_class: 'disabled',

    _get_html: function () {
      return this.html;
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/_item.js
 ** module id = 5
 ** module chunks = 0
 **/